import React, { useState } from "react";
import { showToast } from "../../utils/toast";

const ContactUsFormDetails = () => {
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        phone: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const BACKEND_URL = process.env.REACT_APP_API_BASE_URL || '';

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        
        // Validation
        if (!formData.firstName.trim()) {
            showToast.error('First name is required');
            return;
        }
        if (!formData.lastName.trim()) {
            showToast.error('Last name is required');
            return;
        }
        if (!formData.email.trim()) {
            showToast.error('Email is required');
            return;
        }
        if (!formData.subject.trim()) {
            showToast.error('Subject is required');
            return;
        }
        if (!formData.message.trim()) {
            showToast.error('Message is required');
            return;
        }

        // Email validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            showToast.error('Please enter a valid email address');
            return;
        }

        setIsSubmitting(true);

        try {
            const response = await fetch(`${BACKEND_URL}/api/contact`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(formData)
            });

            const data = await response.json();

            if (response.ok) {
                showToast.success(data.message, {
                    position: 'top-center',
                    autoClose: 5000,
                });
                
                // Reset form
                setFormData({
                    firstName: '',
                    lastName: '',
                    email: '',
                    phone: '',
                    subject: '',
                    message: ''
                });
            } else {
                showToast.error(data.error || 'Failed to submit contact form');
            }
        } catch (error) {
            console.error('Contact form error:', error);
            showToast.error('Network error. Please try again.');
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <>
        <div className="space100"></div>
            <div className="contact-page">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-6">
                            <div className="contact-boxs">
                                <div className="heading1">
                                    <h2>Contact Information</h2>
                                    <div className="space16"></div>
                                    <p>We've grown up with the internet revolution, and we <br /> know how to deliver on its</p>
                                </div>
                                <div className="contact-box">
                                    <div className="icon">
                                        <img src="assets/img/icons/contact-page-icon1.png" alt="" />
                                    </div>
                                    <div className="heading">
                                        <h5>Contact Us</h5>
                                        <a href="tel:9817800346" className="text">9817800346</a>
                                    </div>
                                </div>

                                <div className="contact-box">
                                    <div className="icon">
                                        <img src="assets/img/icons/contact-page-icon2.png" alt="" />
                                    </div>
                                    <div className="heading">
                                        <h5>Send Us a Mail</h5>
                                        <a href="mailto:contact@ibrlive.com" className="text">contact@ibrlive.com</a>
                                    </div>
                                </div>

                                <div className="contact-box">
                                    <div className="icon">
                                        <img src="assets/img/icons/contact-page-icon3.png" alt="" />
                                    </div>
                                    <div className="heading">
                                        <h5>Office Location</h5>
                                        <p className="text">SCO 159, Second Floor, Sector 13-17, <br /> Panipat, Haryana-132103</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-6">
                            <div className="contact-form-details">
                                <form onSubmit={handleSubmit}>
                                    <div className="row">
                                        <div className="col-lg-6">
                                            <div className="single-input">
                                                <input 
                                                    type="text" 
                                                    name="firstName"
                                                    placeholder="First Name" 
                                                    value={formData.firstName}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="single-input">
                                                <input 
                                                    type="text" 
                                                    name="lastName"
                                                    placeholder="Last Name" 
                                                    value={formData.lastName}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="single-input">
                                                <input 
                                                    type="email" 
                                                    name="email"
                                                    placeholder="Email" 
                                                    value={formData.email}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-6">
                                            <div className="single-input">
                                                <input 
                                                    type="tel" 
                                                    name="phone"
                                                    placeholder="Phone (Optional)" 
                                                    value={formData.phone}
                                                    onChange={handleInputChange}
                                                />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="single-input">
                                                <input 
                                                    type="text" 
                                                    name="subject"
                                                    placeholder="Subject" 
                                                    value={formData.subject}
                                                    onChange={handleInputChange}
                                                    required
                                                />
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <div className="single-input">
                                                <textarea 
                                                    name="message"
                                                    cols="30" 
                                                    rows="5" 
                                                    placeholder="Message"
                                                    value={formData.message}
                                                    onChange={handleInputChange}
                                                    required
                                                ></textarea>
                                            </div>
                                        </div>

                                        <div className="col-lg-12">
                                            <button 
                                                type="submit" 
                                                className="theme-btn1"
                                                disabled={isSubmitting}
                                            >
                                                {isSubmitting ? 'Sending...' : 'Submit'} 
                                                <span><i className="fa-solid fa-arrow-right"></i></span>
                                            </button>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="space100"></div>
            <div className="contact-map-page">
            <iframe 
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d893729.4484447829!2d76.3686118198095!3d28.953848877234364!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x390e476882ae2b0d%3A0x5871cf5b392f94ea!2sIBRLIVE%20INDIA%20PRIVATE%20LIMITED!5e0!3m2!1sen!2sin!4v1753959975202!5m2!1sen!2sin"
                width="600" 
                height="450" 
                style={{border:0}} 
                allowFullScreen="" 
                loading="lazy" 
                referrerPolicy="no-referrer-when-downgrade"
                title="Google Maps"
            ></iframe>
          </div>
        </>
    );
};

export default ContactUsFormDetails;